import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Loader from "@/components/Loader";

export default function AdminBilletterie() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [refreshing, setRefreshing] = useState(false);

  const load = async (force = false) => {
    setError("");
    setRefreshing(true);
    try {
      const { data } = await api.get(`/admin/tickets/sales${force ? "?force=true" : ""}`);
      setData(data);
    } catch (e) { setError(e?.response?.data?.detail || "Erreur"); }
    finally { setRefreshing(false); }
  };
  useEffect(() => { load(false); }, []);

  return (
    <div className="p-4 md:p-8 max-w-6xl">
      <div className="flex flex-wrap justify-between items-center gap-3 mb-4">
        <div>
          <h1 className="text-3xl font-black">Billetterie</h1>
          <p className="text-neutral-400 text-sm">Ventes billets via Infomaniak eTickets</p>
        </div>
        <button onClick={() => load(true)} disabled={refreshing} className="brand-gradient-btn px-4 py-2 rounded-lg">
          {refreshing ? "…" : "Actualiser (force)"}
        </button>
      </div>

      {error && <div className="card-hsg p-4 text-red-400 mb-4">⚠️ {error}</div>}
      {!data ? <Loader label="Chargement des ventes…" /> : (
        <>
          <div className="card-hsg p-6 mb-4 text-center">
            <div className="text-neutral-400 text-sm">Total billets vendus</div>
            <div className="text-6xl font-black mt-2 gradient-text inline-block">{data.total_sold}</div>
            <div className="text-xs text-neutral-500 mt-2">Mise à jour : {new Date(data.fetched_at).toLocaleString("fr-CH")} {data.cached && "(cache)"}</div>
          </div>

          <div className="space-y-4">
            {(data.events || []).map((ev) => (
              <div key={ev.event_id} className="card-hsg p-5">
                <div className="flex flex-wrap justify-between gap-2">
                  <div>
                    <div className="font-bold text-lg">{ev.name}</div>
                    <div className="text-neutral-400 text-sm">{ev.date} — {ev.status}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-3xl font-black">{ev.total_sold}</div>
                    <div className="text-xs text-neutral-500">{ev.quota != null ? `Quota ${ev.quota}` : ""}</div>
                  </div>
                </div>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2 mt-3">
                  {(ev.zones || []).map((z) => (
                    <div key={z.name} className="bg-neutral-900 rounded-lg p-3 border-l-4" style={{ borderLeftColor: z.color_hex }}>
                      <div className="flex justify-between">
                        <div className="font-semibold text-sm">{z.name}</div>
                        <div className="font-bold">{z.sold}</div>
                      </div>
                      {(z.tarifs || []).map((t, i) => (
                        <div key={i} className="flex justify-between text-xs text-neutral-400 mt-1">
                          <span>{t.name}</span><span>{t.sold}</span>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
